import { useTheme } from "../../hooks/useTheme";
import "./ThemeToggle.css";

interface ThemeToggleProps {
  className?: string;
}

export default function ThemeToggle({ className = "" }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
        type="button"
        className={`theme-toggle ${className}`.trim()}
        onClick={toggleTheme}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        title={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? (
          // Sun — shown when dark is active, click to go light.
          <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <circle cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
            <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M12 2.5v2.5" />
              <path d="M12 19v2.5" />
              <path d="M4.4 4.4l1.8 1.8" />
              <path d="M17.8 17.8l1.8 1.8" />
              <path d="M2.5 12h2.5" />
              <path d="M19 12h2.5" />
              <path d="M4.4 19.6l1.8-1.8" />
              <path d="M17.8 6.2l1.8-1.8" />
            </g>
          </svg>
      ) : (
          // Moon — shown when light is active, click to go dark.
          <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path
                d="M20 14.2A8.5 8.5 0 1 1 9.8 4a6.8 6.8 0 0 0 10.2 10.2Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinejoin="round"
            />
          </svg>
      )}
    </button>
  );
}
